import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-tree-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomTreeNode = _resolveComponent("CustomTreeNode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.treeData, (node) => {
      return (_openBlock(), _createBlock(_component_CustomTreeNode, {
        ref_for: true,
        ref: "rootRefs",
        key: node.id,
        node: node,
        fields: _ctx.fields,
        selectedNodes: _ctx.modelValue,
        disabledNodes: _ctx.disabledNodes,
        onCheckChange: _ctx.handleCheckChange
      }, null, 8, ["node", "fields", "selectedNodes", "disabledNodes", "onCheckChange"]))
    }), 128))
  ]))
}